import React, { FC, memo } from "react";

import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { Flex } from "@/eworkitComponents";

import "./_check-list-item.scss";

interface ICheckListItemProps {
  text: string;
}

export const CheckListItem: FC<ICheckListItemProps> = memo(props => {
  const baseClass = "check-list-item";

  return (
    <Flex className={baseClass} direction="row" innerMargin="sm">
      <Icon color="success" icon="checkbox" size="lg" />
      <Text className={`${baseClass}__text`} color="black" size="md">
        {props.text}
      </Text>
    </Flex>
  );
});
